/* Nightform — storefront behaviour.
   Everything here is progressive. With this file blocked the page still reads,
   and the buy box falls back to the <noscript> variant select, which posts a
   real variant id to /cart/add. The hidden id input stays disabled until this
   script enables it, so the two can never both submit.

   1. Carousel arrows, injected rather than hard-coded, so a rail with one slide
      never shows dead controls.
   2. Variant selection across two options: a price ladder and colour swatches.
   3. The two-brace tier lets you pick a colour per brace.
   4. Re-runs on shopify:section:load so the theme editor stays live. */
(function () {
  function rails(root) {
    root.querySelectorAll('.nf .rail').forEach(function (rail) {
      if (rail.dataset.bound) return;
      rail.dataset.bound = '1';
      if (rail.children.length < 2) return;

      var nav = document.createElement('div');
      nav.className = 'railnav';
      nav.innerHTML =
        '<button type="button" aria-label="Previous"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 5l-7 7 7 7"/></svg></button>' +
        '<button type="button" aria-label="Next"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 5l7 7-7 7"/></svg></button>';
      rail.parentNode.insertBefore(nav, rail);
      var b = nav.querySelectorAll('button');

      function step(dir) {
        var c = rail.firstElementChild;
        if (!c) return;
        rail.scrollBy({ left: dir * (c.getBoundingClientRect().width + 16), behavior: 'smooth' });
      }
      b[0].addEventListener('click', function () { step(-1); });
      b[1].addEventListener('click', function () { step(1); });

      function sync() {
        b[0].disabled = rail.scrollLeft < 4;
        b[1].disabled = rail.scrollLeft > rail.scrollWidth - rail.clientWidth - 4;
        nav.style.display = rail.scrollWidth <= rail.clientWidth + 4 ? 'none' : '';
      }
      rail.addEventListener('scroll', sync);
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ---------------------------------------------------------------- colour pairs

     Two braces can be two different colours. Those are real variants, whose
     Colour value names the pair: "White + Grey". Nothing in Liquid knows that —
     it renders one swatch per option value — so this file does three things:

     1. Pair values never appear in the swatch row. They are how the catalogue
        stores a pair, not something to pick from a row of dots.
     2. The tier that has pair variants grows two dropdowns, one per brace. The
        swatch row stays the control for brace one and the two move together;
        brace two follows along until the shopper sets it themselves, and then
        it is left alone.
     3. match() returns null for a combination the catalogue does not have. The
        old code left the PREVIOUS variant id sitting in the form when that
        happened — so going from two braces back to one would have posted the
        two-brace variant. Nothing is ever submitted now that the selection does
        not actually name.

     Hiding uses `[hidden]` paired with an explicit rule below, because
     `.nf .sw{display:flex}` (0,2,0) outranks the user agent's
     `[hidden]{display:none}` (0,1,0) and the element would stay on screen. */

  var PAIR = ' + ';
  var STYLE_ID = 'nf-pair-css';

  function isPair(value) { return !!value && value.indexOf(PAIR) > -1; }
  function partsOf(value) {
    return isPair(value) ? value.split(PAIR).map(function (s) { return s.trim(); }) : [value];
  }

  function styles() {
    if (document.getElementById(STYLE_ID)) return;
    var el = document.createElement('style');
    el.id = STYLE_ID;
    el.textContent =
      '.nf .sw[hidden],.nf .nfpair[hidden]{display:none}' +
      '.nf .nfpair{grid-column:2/-1;display:grid;gap:7px;margin-top:11px}' +
      '.nf .nfpair__r{display:grid;grid-template-columns:auto minmax(0,1fr);align-items:center;gap:10px}' +
      '.nf .nfpair__l{font-size:12px;color:var(--muted)}' +
      '.nf .nfpair select{font:inherit;font-size:13px;font-weight:600;color:var(--ink);' +
      'padding:7px 26px 7px 10px;border:1px solid var(--line2);border-radius:9px;' +
      'background:var(--g3);width:100%;max-width:200px;cursor:pointer}' +
      '.nf .nfpair select:focus-visible{outline:2px solid var(--acc);outline-offset:2px}' +
      '.nf .nfpair__n{font-size:12px;color:#8A3B2F;margin:0}';
    document.head.appendChild(el);
  }

  function buybox(root) {
    root.querySelectorAll('.nf form[action*="/cart/add"]').forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';

      var scope = form.closest('.prod') || form.parentNode;
      var data = scope.querySelector('.nf-vardata');
      var idInput = form.querySelector('.nf-varid');
      if (!data || !idInput) return;

      var variants;
      try { variants = JSON.parse(data.textContent); } catch (e) { return; }
      if (!variants || !variants.length) return;

      /* the script is running, so the hidden input is the one that submits
         and the <noscript> select was never rendered */
      idInput.disabled = false;

      var tiers = form.querySelector('.tiers');
      var swatches = form.querySelector('.swatches');
      var swName = form.querySelector('.nf-swname');
      var addBtn = form.querySelector('button[name="add"]');
      var swEls = swatches ? [].slice.call(swatches.querySelectorAll('.sw')) : [];

      function radioIn(el) { return el.querySelector('input[type=radio]'); }
      function valueOf(el) { var r = radioIn(el); return r ? r.value : null; }
      function chosen(box) {
        if (!box) return null;
        var r = box.querySelector('input[type=radio]:checked');
        return r ? r.value : null;
      }
      function match(a, b) {
        return variants.filter(function (v) {
          return (a === null || v.o.indexOf(a) > -1) && (b === null || v.o.indexOf(b) > -1);
        })[0] || null;
      }

      /* The swatch row is single colours only, from here on. */
      var singles = [];
      swEls.forEach(function (el) {
        var v = valueOf(el);
        if (isPair(v)) { el.hidden = true; var r = radioIn(el); if (r) r.disabled = true; }
        else if (v) singles.push(v);
      });

      function setSwatch(value, announce) {
        var hit = null;
        swEls.forEach(function (el) {
          var r = radioIn(el);
          if (r && r.value === value) { r.checked = true; hit = r; }
        });
        /* letting the event out is what makes the gallery follow the colour */
        if (hit && announce) hit.dispatchEvent(new Event('change', { bubbles: true }));
        return hit;
      }

      /* ---- the per-brace dropdowns, on whichever tier has pair variants ---- */
      var pairTier = null, picker = null, selA = null, selB = null, note = null;
      var bTouched = false;

      if (tiers && singles.length > 1) {
        [].slice.call(tiers.querySelectorAll('.tier')).forEach(function (tierEl) {
          var v = valueOf(tierEl);
          if (pairTier || !v) return;
          var hasPairs = variants.some(function (vr) {
            return vr.o.indexOf(v) > -1 && vr.o.some(isPair);
          });
          if (!hasPairs) return;
          pairTier = v;
          picker = build(tierEl);
        });
      }

      function build(tierEl) {
        styles();
        var box = document.createElement('div');
        box.className = 'nfpair';
        box.innerHTML =
          row('Brace 1') + row('Brace 2') +
          '<p class="nfpair__n" hidden>That pair is not available. Pick another colour.</p>';
        tierEl.appendChild(box);

        var sels = box.querySelectorAll('select');
        selA = sels[0];
        selB = sels[1];
        note = box.querySelector('.nfpair__n');

        /* A <select> inside a <label> keeps its own clicks: the browser does not
           forward activation to the label's control from interactive content. */
        selA.addEventListener('change', function () { setSwatch(selA.value, true); apply(); });
        selB.addEventListener('change', function () { bTouched = true; apply(); });
        return box;

        function row(label) {
          var opts = singles.map(function (c) {
            return '<option value="' + esc(c) + '">' + esc(c) + '</option>';
          }).join('');
          return '<span class="nfpair__r"><span class="nfpair__l">' + esc(label) + '</span>' +
            '<select aria-label="' + esc(label) + ' colour">' + opts + '</select></span>';
        }
      }

      function esc(s) {
        return String(s).replace(/[&<>"]/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
        });
      }

      /* A deep link can arrive on a pair variant (?variant=…), which Liquid
         renders as a checked swatch we have just hidden. Unpick it onto the two
         dropdowns so the shopper sees the selection they followed. */
      (function seed() {
        var c = chosen(swatches);
        if (!isPair(c)) return;
        var p = partsOf(c);
        if (selA && selB) { selA.value = p[0]; selB.value = p[1]; bTouched = true; }
        setSwatch(p[0], false);
      })();

      /* What colour value the current controls actually name. */
      function colourNow(t) {
        if (!picker || t !== pairTier) return chosen(swatches);
        var a = selA.value, b = selB.value;
        if (a === b) return a;
        if (match(t, a + PAIR + b)) return a + PAIR + b;
        if (match(t, b + PAIR + a)) return b + PAIR + a;
        return null;
      }

      function apply() {
        var t = chosen(tiers);
        var onPair = !!picker && t === pairTier;

        if (picker) {
          picker.hidden = !onPair;
          if (onPair) {
            /* brace one is the swatch row; brace two follows it until touched */
            var sw = chosen(swatches);
            if (sw && singles.indexOf(sw) > -1) selA.value = sw;
            if (!bTouched) selB.value = selA.value;
          }
        }

        var c = colourNow(t);
        var v = c === null ? null : match(t, c);
        if (v) idInput.value = v.id;
        if (note) note.hidden = c !== null;

        if (tiers) {
          tiers.querySelectorAll('.tier').forEach(function (el) {
            var r = radioIn(el);
            el.classList.toggle('tier--on', !!r && r.checked);
          });
        }
        if (swatches) {
          swEls.forEach(function (el) {
            var r = radioIn(el);
            if (el.hidden) return;
            el.classList.toggle('sw--on', !!r && r.checked);
            /* grey out a colour that is sold out in the chosen tier */
            var combo = r ? match(t, r.value) : null;
            el.classList.toggle('sw--out', !!combo && combo.av === false);
          });
          /* the full selection, so a mixed pair reads as one — the sticky bar
             mirrors this line and must not claim a single colour */
          if (swName && c) swName.textContent = c;
        }

        /* Never submit a variant the selection does not name. */
        if (addBtn) addBtn.disabled = !v || v.av === false;
      }

      form.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'radio') apply();
      });
      apply();
    });
  }

  function boot(e) {
    var root = (e && e.target && e.target.querySelectorAll) ? e.target : document;
    rails(root);
    buybox(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
